let React =               require("react");
let ApplicationContext =  require("../../config/ApplicationContext.js");

let Feature =             require("../empty/Feature.jsx");
var Upload3DModelButton = require("../buttons/Upload3DModelButton.jsx");

 class EmptyPackageCard extends React.Component {
    componentWillMount(){
		this.linkPackage = ApplicationContext.getPackageEditor();
    }

    render() {
        return (
        	<div>
                <div className="empty">
                <p>Upload STEP 3D models above or <a href={`${this.linkPackage}?hub=${this.props.idHub}`}>Create a package</a> to get started.</p>
                </div>

	            <Feature idHub={this.props.idHub}/>
            </div>
        );
    }
}


module.exports = EmptyPackageCard;
